/**
** 组织机构： 人员管理
 */
<template>
    <div id="personManage" class="jc-page">
        <div class="jc-panel jc-page-head">
			<div class="header-title">{{ headerTitle }}</div>
			<div class="header-operation">
				<el-form ref="form" :model="form">
                        <el-form-item>
                        <el-input v-model="form.userName" placeholder="用户名"></el-input>
                    </el-form-item>   
                    <!-- <el-form-item> -->
                        <el-button class="button" @click="handleQuery">查询</el-button>
                    <!-- </el-form-item>
                    <el-form-item> -->
                        <el-button class="button" @click="handleDelteMulti">删除</el-button>
                    <!-- </el-form-item>
                    <el-form-item> -->
                        <el-button class="button" @click="dialogVisible = true">添加</el-button>
                    <!-- </el-form-item> -->
                </el-form>
			</div>
		</div>
        <div class="jc-table-container jc-scroll-panel">
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column label="人员姓名">
                        <template slot-scope="scope">{{scope.row.user_real_name}}</template>
                    </el-table-column>
                    <el-table-column label="登录用户名">
                        <template slot-scope="scope">{{scope.row.username}}</template>
                    </el-table-column>
                    <el-table-column label="手机号">
                        <template slot-scope="scope">{{scope.row.user_mobile}}</template>
                    </el-table-column>
                    <el-table-column label="是否是超级管理员"  show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.is_surper=="1"?"是":"否"}}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                            <span>|</span>
                            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    style="text-align:right"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="count"
                    layout="total, prev, pager, next"
                    :total="total"
                    >
                </el-pagination>
        </div>
         
        <el-dialog title="添加人员" :visible.sync="dialogVisible" class="dialog">
            <el-form ref="personForm" :model="personForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="人员姓名">
                            <el-input v-model="personForm.name" placeholder="请输入登录用户名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号">
                            <el-input v-model="personForm.telephone" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="登录用户名">
                            <el-input v-model="personForm.userName" placeholder="请输入登录用户名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否是超级管理员">
                            <el-select v-model="personForm.role" placeholder="请选择">
                                <el-option 
                                    v-for="item in roleOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="密码">
                            <el-input v-model="personForm.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="确认密码">
                            <el-input v-model="personForm.conPassword" placeholder="请再次输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleAdd()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 编辑dialog -->
        <el-dialog title="人员编辑" :visible.sync="detailDialogVisible" class="dialog">
            <el-form ref="detailForm" :model="detailForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="人员姓名">
                            <el-input v-model="detailForm.realname" placeholder="请输入人员姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号">
                            <el-input v-model="detailForm.telephone" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="登录用户名">
                            <el-input v-model="detailForm.userName" placeholder="请输入登录用户名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="密码">
                            <el-input v-model="detailForm.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="确认密码">
                            <el-input v-model="detailForm.conPassword" placeholder="请再次输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleDetailAdd()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {deleteUserInfo, getUserDetail, saveUserInfo, getUserList} from '@/apis/personManage'
export default {
    name:"PersonManage",
    data(){
        return {
            headerTitle:"人员列表",
            multipleSelection:[],//表格
            form:{
                userName:""
            },
            dialogVisible:false,//对话框显示标识
            detailDialogVisible:false,//人员详情dialog显示表示
            tableData:[
                // {
                //     user_real_name:"",
                //     username:"",
                //     user_mobile:"",
                //     is_surper:""
                // }
            ],//表格内容
            personForm:{
                name:"",
                telephone:"",
                userName:"",
                password:"",
                conPassword:"",
                role:""
            },//添加人员对话框内表单
            detailForm:{
                userid:'',
                realname:"",
                telephone:"",
                userName:"",
                password:"",
                conPassword:""
            }, // 人员详情对话框内表单
            roleOptions:[
                {
                    value:'1',
                    label:'是'
                },
                {
                    value:'2',
                    label:'否'
                }
            ],//选择-是否是超级管理员
            currentPage:1,// 当前页数
            count:10,//表格页数
            total:0,// 总条目数
            
        }
    },
    mounted(){
        this.handleQuery()
    },
    methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.handleQuery()
        },
        handleSelectionChange(val){
            this.multipleSelection = [];
            //organization_id
            val.forEach(item => {
            this.multipleSelection.push(parseInt(item.admin_user_id));
            })
            console.log('批量选择',this.multipleSelection);
        },
        // 批量删除--点击头部“删除”按钮
        handleDelteMulti(){
            this.$confirm('是否确定删除数据？', "提示").then(()=>{
                deleteUserInfo({admin_user_id_list:this.multipleSelection}).then(res => {
                console.log('批量删除',res);
                 if(res.data.status == "1"){
                     this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.handleQuery();
                }else{
                    this.$message.error('删除失败！');
                }
            })
            })
            
        },
        // 表格中点击"删除"
        handleDelete(index,row){
            this.$confirm('是否确定删除数据？', "提示").then(()=>{
                // console.log('删除',index,row);
            deleteUserInfo({admin_user_id_list:[row.admin_user_id]}).then(res => {
                console.log('单个删除',res);
                 if(res.data.status == "1"){
                     this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.handleQuery();
                }else{
                    this.$message.error('删除失败！');
                }
            })
            })
            
        },
        // 点击表格中"编辑"--11-获得人员详情
        handleEdit(index,row){
            console.log('编辑',index,row);
            this.detailDialogVisible = true;
            getUserDetail({
                    admin_user_id:row.admin_user_id
                }).then(res => {
                console.log('人员详情',res);
                if(res.status == 200 || res.data.status == "1"){
                    let data = res.data.data.user_info
                    this.detailForm.realname = data.user_real_name;
                    this.detailForm.telephone = data.user_mobile;
                    this.detailForm.userName = data.username;
                    this.detailForm.role = data.username;
                    this.detailForm.userid = data.admin_user_id
                }
            })
        },
        // 点击详情人员dialog框中“确定”按钮
        handleDetailAdd(){
            if(this.detailForm.password != this.detailForm.conPassword){
               this.$message({
                        message: '密码不一致',
                        type: 'error'
                    });
                    return
           }

            let obj = {
                admin_user_id:this.detailForm.userid,
                user_real_name:this.detailForm.realname,
                user_mobile:this.detailForm.telephone,
                username:this.detailForm.userName,
                password:this.detailForm.password
            };
            saveUserInfo(obj).then(res => {
                console.log('保存人员信息',res);
                if(res.data.status == "1" ){
                     this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.detailDialogVisible = false;
                    this.handleQuery();
                }else {
                    this.$message.error(`${res.data.msg}`);
                }
            })
        },
        // 点击头部“查询”按钮
        // 10-人员-获得人员列表
        handleQuery(){
            // if(this.form.userName === ""){
            //     this.$message.error('查询条件不用为空');
            //     return;
            // };
            let obj = {
                user_real_name:this.form.userName,
                pagination:{
                    page:this.currentPage,
                    count:this.count
                }
            };
            getUserList(obj).then(res => {
                console.log('人员列表',res);
                if(res.data.status == "1" ){
                    this.tableData = res.data.data.user_list;
                    this.total = parseInt(res.data.data.paginated.total)
                     this.$message({
                        message: '查询成功！',
                        type: 'success'
                    });
                }else {
                    this.$message.error(`${res.data.msg}`);
                }
            })
        },
        // 点击"对话框"中“确定”按钮---12-人员-保存人员信息
        handleAdd(){
           if(this.personForm.password != this.personForm.conPassword){
               this.$message({
                        message: '密码不一致',
                        type: 'error'
                    });
                    return
           }
            let obj = {
                admin_user_id:"0",
                user_real_name:this.personForm.name,
                user_mobile:this.personForm.telephone,
                username:this.personForm.userName,
                password:this.personForm.password
            };
            saveUserInfo(obj).then(res => {
                console.log('保存人员信息',res);
                if(res.data.status == "1" ){
                     this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.handleQuery();
                    this.personForm = {
                        name:"",
                        telephone:"",
                        userName:"",
                        password:"",
                        conPassword:"",
                        role:""
                    }
                }else {
                    this.$message.error(`${res.data.msg}`);
                }
            })
        },
    }
}
</script>
<style scoped>
#personManage{
    position: relative;
}
.header {
    width: 100%;
    height: 35px !important;
    border-bottom: 1px solid #ccc;
}
.header-left {
    width: 200px;
    text-align: left;
    position: absolute;
}
.header-title {
    font-weight: bold;
}
.header-right {
    position: absolute;
    right: 20px;
    /* width: 30%; */
    height: 35px;
    top: -15px;
}
.el-form{
    display: flex;
    height: 35px;
}
.el-form-item {
    width: 180px;
    margin-right: 10px;
}
.button {
    height: 38px;
    color: #fff;
    background-color: #000;
}
#personManage >>> .el-input__inner {
    height: 35px;
    padding: 0 10px;
    border: 1px solid #000;
}
#personManage >>> .el-input input::-webkit-input-placeholder{
    color: #9e9fa3;
}
/* 表格样式修改 */
.el-table{
    color: #000;
}
#personManage >>> .el-table thead{
    color:#000;
    font-weight: unset;
}
#personManage >>> .el-table__header{
    width: 100%;
   
}
#personManage >>> .el-table th.el-table__cell{
    background-color: #f3f3f3;
}
/* #organlist >>> .el-table tr{
    
} */
#personManage >>> .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: unset;
}
.el-button--text{
    color: #000;
    font-size: 13px;
}
.el-table__row>td{
    border: none;
}
.el-table::before{
    height: 0px;
}
#personManage >>> .el-checkbox__inner{
    width: 16px;
    height: 16px;
    border: 1px solid #9e9fa3;
}
/* 对话框样式修改 */
#personManage >>> .dialog .el-dialog__header{
    text-align: left;
}
#personManage >>> .dialog .el-dialog__title{
    font-size: 20px; 
}
#personManage >>> .dialog .el-dialog__body{
    padding: 10px 20px;
    color: #000;
}
#personManage >>> .dialog .el-dialog__body .el-form{
    width: 100%;
    height: 100%;
    display: block;
}
#personManage >>> .dialog .el-dialog__body .el-form-item {
    width: 85%;
    margin-bottom: 15px;
}
#personManage >>> .dialog .el-form-item__label{
    color: #000;
    font-size: 16px;
    text-align: left;
    line-height: 35px;
}
#personManage >>> .dialog .el-input__inner {
    border: 1px solid #409eff;
    color: #000;
}
#personManage >>> .dialog .el-select {
    width: 100%;
}
#personManage >>> .dialog .el-dialog__footer {
    padding: 0px 20px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/backStage/children/PersonManage/PersonManage.vue